export const LAUNCH_COMERCIA_IS_AVALIABLE = 'LAUNCH_COMERCIA_IS_AVALIABLE';
export const COMERCIA_IS_AVALIABLE_API_REQUEST = 'COMERCIA_IS_AVALIABLE_API_REQUEST';
export const COMERCIA_IS_AVALIABLE_API_SUCCESS = 'COMERCIA_IS_AVALIABLE_API_SUCCESS';
export const COMERCIA_IS_AVALIABLE_API_FAILURE = 'COMERCIA_IS_AVALIABLE_API_FAILURE';

export const LAUNCH_COMERCIA_AUTHORIZE = 'LAUNCH_COMERCIA_AUTHORIZE';
export const COMERCIA_AUTHORIZE_API_REQUEST = 'COMERCIA_AUTHORIZE_API_REQUEST';
export const COMERCIA_AUTHORIZE_API_SUCCESS = 'COMERCIA_AUTHORIZE_API_SUCCESS';
export const COMERCIA_AUTHORIZE_API_FAILURE = 'COMERCIA_AUTHORIZE_API_FAILURE';

export const LAUNCH_COMERCIA_REBATE = 'LAUNCH_COMERCIA_REBATE';
export const COMERCIA_REBATE_API_REQUEST = 'COMERCIA_REBATE_API_REQUEST';
export const COMERCIA_REBATE_API_SUCCESS = 'COMERCIA_REBATE_API_SUCCESS';
export const COMERCIA_REBATE_API_FAILURE = 'COMERCIA_REBATE_API_FAILURE';

export const LAUNCH_COMERCIA_COMPLETE = 'LAUNCH_COMERCIA_COMPLETE';
export const COMERCIA_COMPLETE_API_REQUEST = 'COMERCIA_COMPLETE_API_REQUEST';
export const COMERCIA_COMPLETE_API_SUCCESS = 'COMERCIA_COMPLETE_API_SUCCESS';
export const COMERCIA_COMPLETE_API_FAILURE = 'COMERCIA_COMPLETE_API_FAILURE';

export const COMERCIA_NEW_TRANSACTION_REQUEST = 'COMERCIA_NEW_TRANSACTION_REQUEST';
export const COMERCIA_NEW_TRANSACTION_SUCCESS = 'COMERCIA_NEW_TRANSACTION_SUCCESS';
export const COMERCIA_NEW_TRANSACTION_FAILURE = 'COMERCIA_NEW_TRANSACTION_FAILURE';
